<template>
<div class="chapter">
<div class="inner_page">
<h1 class="CHAP-TITLE1">A few tips before you start</h1>
<p class="SbS1"><span class="big-number">1.</span><span class="space">Read the label carefully on the ball of yarn (composition, length, weight, recommended size of crochet hook and care instructions) and refer to the Materials section to check that your yarn is suitable for the motif you want to make.</span></p>
<p class="SbS1"><span class="big-number">2.</span><span class="space">Before starting, always check your tension, making a sample to ensure that your yarn and crochet hook are suitable and that your measurements match those given in the instructions.</span></p>
<p class="SbS1"><span class="big-number">3.</span><span class="space">Instructions given between two asterisks (*) indicate stitches that need to be repeated.</span></p>
<p class="SbS1"><span class="big-number">4.</span><span class="space">The loop on the hook is never counted as a stitch.</span></p>
<p class="SbS1"><span class="big-number">5.</span><span class="space">Read all the pattern instructions in full before starting, to be sure you have understood them all.</span></p>
<p class="SbS1"><span class="big-number">6.</span><span class="space">Always insert the hook into the work from front to back, unless indicated otherwise.</span></p>
<p class="SbS1"><span class="big-number">7.</span><span class="space">Always insert the hook under the two loops at the top of the stitches, unless indicated otherwise.</span></p>
<p class="SbS1"><span class="big-number">8.</span><span class="space">There should always be one loop remaining on the hook once a stitch has been completed, unless indicated otherwise.</span></p>
<p class="SbS1"><span class="big-number">9.</span><span class="space">Begin every row by inserting the hook as indicated into the turning chain stitches.</span></p>
<p class="SbS1"><span class="big-number">10.</span><span class="space1">Always block your motif following the instructions on the yarn ball band.</span></p>
<p class="SbS1"><span class="big-number">11.</span><span class="space1">Have fun! Change the colours and materials used in the motifs, follow your own instincts and style, and make the designs your own.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter2-1.vue?cb0f4394